// removed by extract-text-webpack-plugin
module.exports = {"metricContainer":"metricContainer-UqNKP","metricIcon":"metricIcon-1zGEE","metricValue":"metricValue-sNEzO","metricLabel":"metricLabel-2R20f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/view/_performanceMetric.css
// module id = 1204
// module chunks = 1